import { useCart } from '@framework/cart'
import { Button } from '@noissue-ui-kit/button'
import { useState } from 'react'
import * as Sentry from '@sentry/nextjs'
import { useUI } from 'app/_components/ui'
import { trackSkipEditorAction } from '@utils/gtm'
import useUploaderToCart from 'app/(main)/(catalog)/upload/[slug]/_components/designUpload/hooks/useUploaderToCart/useUploaderToCart'

export function AddToCartOption({
  productSlug,
  productOption,
}: {
  productSlug: string
  productOption: any
}) {
  const { data: cartContent } = useCart()
  const [addItemToCart] = useUploaderToCart()
  const [addToCartLoading, setAddToCartLoading] = useState(false)
  const { openSidebar } = useUI()
  const [addToCartError, setAddToCartError] = useState(null)

  const addToCart = async () => {
    try {
      setAddToCartLoading(true)
      await addItemToCart({
        cartContent,
        productCategorySlug: productSlug,
        selection: productOption,
        designJourney: 'skip-artwork',
      })
      openSidebar()

      trackSkipEditorAction({
        currencyCode: productOption?.currencyCode,
        name: productOption?.name,
        price: productOption?.price,
        quantity: productOption?.quantity,
        sku: productOption?.variantSku,
      })
    } catch (error) {
      Sentry.captureException(error)
      setAddToCartError(
        typeof error === 'string'
          ? error
          : error.message || 'An error occurred while adding to cart'
      )
    } finally {
      setAddToCartLoading(false)
    }
  }

  return (
    <>
      {addToCartError && (
        <p className="mb-8 text-xl text-error font-mori">{addToCartError}</p>
      )}

      <Button
        size={'m'}
        corners={'rounded'}
        colour={'pitaya'}
        variant={'outline'}
        className="w-full"
        onClick={() => addToCart()}
        loading={addToCartLoading}
        disabled={addToCartLoading}
      >
        Design later — Add to cart
      </Button>
    </>
  )
}
